<div class="cppMarketingLandingPage">
  <div class="row headerSection">
    <div class="col-3 ml-4">
      <h2 class="mb-0 ml-2">
        MARKETING PROGRAMS
      </h2>
    </div>
    <div class="col-4 d-flex align-items-center ml-3 dateTimeSection ">
      <p class="mb-0 text-uppercase">
        {{ formattedDate }}
      </p>
    </div>
  </div>

  <div class="newLandingPageOrdersTabSection">
    <div class="order-top-sec">
      <div>
        <h3 class="my-3 mx-1">MARKETING PROGRAM SUMMARY</h3>
        <p class="my-3 mx-1"> Select the program details you wish from the dropdown menus and click the filter button to view the results.</p>
      </div>
      <div class="addBorder">
        <div class="dropdownSectionOne">
          <ng-select [items]="manufacturerList"
                     bindLabel="value"
                     placeholder="Manufacturer"
                     bindValue="id"
                     [multiple]="true"
                     [clearable]="false"
                     [closeOnSelect]="false"
                     [searchable]="false">

          <ng-template ng-option-tmp let-item="item">
            <div (click)="toggleSelect(item,'manufacturer')">
              <mat-checkbox #Allcheck2 class="custom-checkbox select-all-check"
                            [checked]="item.selected"></mat-checkbox>
              {{ item.value }}
              <span *ngIf="item.id !== 'view-all'" (click)="toggleFavorite(item, $event)">
                <i [ngClass]="item.favorite ? 'fa fa-regular fa-star' : 'far fa-star'"></i>
              </span>
            </div>
          </ng-template>

            <ng-template ng-multi-label-tmp let-items="items">
              <div class="ng-value" style="padding-left:70px">
                <span class="ng-value-label">({{selectedManufacturerLength}} Selected)</span>
              </div>
            </ng-template>

          </ng-select>
        </div>
        <div class="dropdownSectionOne">
          <ng-select [items]="programList"
                     bindLabel="value"
                     placeholder="Programs"
                     bindValue="id"
                     [multiple]="true"
                     [clearable]="false"
                     [closeOnSelect]="false"
                     [searchable]="false">

            <ng-template ng-option-tmp let-item="item">
              <div (click)="toggleSelect(item,'program')">
                <mat-checkbox #Allcheck class="custom-checkbox select-all-check"
                              [checked]="item.selected"></mat-checkbox>
                {{ item.value }}
              </div>
            </ng-template>

            <ng-template ng-multi-label-tmp let-items="items">
              <div class="ng-value" style="padding-left:50px">
                <span class="ng-value-label">({{selectedProgramsLength}} Selected)</span>
              </div>
            </ng-template>

          </ng-select>
        </div>
        <div class="dropdownSectionOne">
          <button mat-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" class="selectDateRange text-left">
            Order Period <i class="arrow down"></i>
          </button>
          <mat-menu #menu="matMenu" class="dropdown-content-new" [hasBackdrop]="true">
            <div class="filter-container" (click)="$event.stopPropagation()">
              <div class="dropdown-container">
                <!-- Headers for Year and Month -->
                <div class="dropdown-header">
                  <span></span> <!-- Empty placeholder for alignment -->
                  <span class="header-label">Year</span>
                  <span class="header-label">Month</span>
                </div>

                <!-- Row 1: From -->
                <div class="dropdown-row">
                  <label>From</label>
                  <mat-form-field appearance="outline">
                    <mat-select [(value)]="filters.fromYearorder" (click)="$event.stopPropagation()" (selectionChange)="applyFilters('order')">
                      <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-select [(value)]="filters.fromMonthorder" (click)="$event.stopPropagation()" (selectionChange)="applyFilters('order')">
                      <mat-option *ngFor="let month of months" [value]="month.value">{{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Row 2: To -->
                <div class="dropdown-row">
                  <label>To</label>
                  <mat-form-field appearance="outline">
                    <mat-select [(value)]="filters.toYearorder" (click)="$event.stopPropagation()" (selectionChange)="applyFilters('order')">
                      <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-select [(value)]="filters.toMonthorder" (click)="$event.stopPropagation()" (selectionChange)="applyFilters('order')">
                      <mat-option *ngFor="let month of months" [value]="month.value">{{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <!-- Buttons -->
              <!--<div class="button-container">
          <button mat-button class="cancel-btn" (click)="clearFilters('order')">CANCEL</button>
          <button mat-raised-button [disabled]="!(filters.fromYearorder && filters.fromMonthorder != null && filters.toYearorder && filters.toMonthorder != null)" color="primary apply-btn" (click)="applyFilters('order')">APPLY</button>
        </div>-->
            </div>
          </mat-menu>

        </div>
        <div class="dropdownSectionOne">
          <button mat-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu2" class="selectDateRange text-left">
            Ship Period <i class="arrow down"></i>
          </button>
          <mat-menu #menu2="matMenu" class="dropdown-content-new" style="" [hasBackdrop]="true">
            <div class="filter-container" (click)="$event.stopPropagation()">

              <div class="dropdown-container">
                <!-- Headers for Year and Month -->
                <div class="dropdown-header">
                  <span></span> <!-- Empty placeholder for alignment -->
                  <span class="header-label">Year</span>
                  <span class="header-label">Month</span>
                </div>

                <!-- Row 1: From -->
                <div class="dropdown-row">
                  <label>From</label>
                  <mat-form-field appearance="outline">
                    <mat-select [(value)]="filters.fromYearShip" (click)="$event.stopPropagation()" (selectionChange)="applyFilters('ship')">
                      <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-select [(value)]="filters.fromMonthShip" (click)="$event.stopPropagation()" (selectionChange)="applyFilters('ship')">
                      <mat-option *ngFor="let month of months" [value]="month.value">{{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Row 2: To -->
                <div class="dropdown-row">
                  <label>To</label>
                  <mat-form-field appearance="outline">
                    <mat-select [(value)]="filters.toYearShip" (click)="$event.stopPropagation()" (selectionChange)="applyFilters('ship')">
                      <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-select [(value)]="filters.toMonthShip" (click)="$event.stopPropagation()" (selectionChange)="applyFilters('ship')">
                      <mat-option *ngFor="let month of months" [value]="month.value">{{ month.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <!-- Buttons -->
              <!--<div class="button-container">
          <button mat-button class="cancel-btn" (click)="clearFilters('ship')">CANCEL</button>
          <button mat-raised-button color="primary apply-btn" [disabled]="!(filters.fromYearShip && filters.fromMonthShip != null && filters.toYearShip && filters.toMonthShip != null)" (click)="applyFilters('ship')">APPLY</button>
        </div>-->
            </div>
          </mat-menu>

        </div>
        <div class="buttonSection text-right">
          <div class="search-btn">
            <button mat-raised-button class="btns wide70" (click)="setFilterData()" color="primary">Filter</button>
            <span class="" style="width: 30%; display: inline-block;text-align: center;"><a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a></span>
          </div>
        </div>
      </div>
      <div class="noBorder">
        <div class="toggleSection">
          <div class="row">
            <div class="col-8 text-right">DISPLAY: <b> {{ activeRecords === "Y" ? "ACTIVE" : "INACTIVE" }}</b> </div>
            <label class="switch">
              <input type="checkbox" (click)="toggleAcitveRecords()" [checked]="activeRecords == 'Y'">
              <span class="slider round"></span>
            </label>
          </div>
        </div>


        <div class="showIcons">
          <img src="../../../../assets/icon/svg/list-view.png" matTooltip="List View" [matTooltipPosition]="'above'" class="list-img" [ngClass]="viewType == 'list' ? 'active':''" (click)="toggleTabs('list')" />
          <img class="tile-view-img" src="../../../../assets/icon/svg/grid-view.png" matTooltip="Tile View" [matTooltipPosition]="'above'" alt="grid-view" [ngClass]="viewType == 'tile' ? 'active':''" (click)="toggleTabs('tile')" />
        </div>
      </div>
      
    </div>
    <div *ngIf="viewType == 'list'">
      <app-cpp-marketing-program-grid-view [marketingProgramDataSource]="marketingProgramDataSource" (toggleFavoriteItems)="toggleFavoriteItem($event)" (downloadProgramFile)="downloadPogramPdfFile($event)"></app-cpp-marketing-program-grid-view>
    </div>
    <div *ngIf="viewType == 'tile'">
      <app-cpp-marketing-program-tile-view [tileViewDataSource]="tileViewDataSource" (toggleFavoriteItems)="toggleFavoriteItem($event)" (downloadProgramFile)="downloadPogramPdfFile($event)"></app-cpp-marketing-program-tile-view>
    </div>
  </div>
</div>
